module.exports = __webpack_public_path__ + "d3fa64228c76050f03e38dc81aab1428.png";